export const bcDateFormats = {
  API_DATE_FORMAT: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'
};
